import {
  Button,
  Col,
  Drawer,
  Empty,
  Form,
  List,
  Row,
  Select,
  // Tooltip,
  // Spin,
} from 'antd';
import { useEffect, useState } from 'react';
import {
  IAPIGameItem,
  IAPIServiceConfigItem,
  CommonStatusStep,
} from '../../../../model/api-modules';
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { IGameEnvModel, IGameEnvSync } from '../../../../model/api-modules/env';
import { serviceOpenList } from '../../../../api/services';
import emptyIcon from '../../../../assets/images/message-empty.png';
import { ArrowRightOutlined } from '@ant-design/icons';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import loadingIcon from '../../../../assets/svg/loading-icon.svg';
import envCheckIcon from '../../../../assets/svg/env-check.svg';
import errorIcon from '../../../../assets/svg/error-icon.svg';
import questionIcon from '../../../../assets/svg/question-icon.svg';
import arrowRightUpIcon from '../../../../assets/svg/arrow-right-up.svg';
import { IEnvUnionItem } from '../../../../model';
import { EnvSyncDetail } from './env-sync-detail';
import getFormatMessage from '../../../../locales/get-format-message';
import { AutoTooltip } from '../../../../components/auto-tooltip';
import { ModalWrap } from '../../../../components/modal-wrap';
import { useHistory } from 'react-router-dom';
import { uniq } from 'lodash';
import { CustomPopover } from '../../../../components/custom-popover';
// import { syncEnv } from '../../../../api/game/env';

interface IProps {
  readonly visible: boolean;
  readonly envList: ReadonlyArray<IGameEnvModel>;
  readonly selectedGame?: IAPIGameItem;
  readonly onClose: () => void;
  readonly allServiceConfig: ReadonlyArray<IAPIServiceConfigItem> | null;
  readonly selectedEnv?: string;
}

enum SubServiceID {
  BattlePass = 'battlepass',
  Season = 'season',
  Matchmaking = 'Matchmaking',
  SkillRating = 'skillrating',
  FactionSet = 'factionset',
  Gamemode = 'gamemode',
}

export const EnvSync = (props: IProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [unionEnvironmentList, setUnionEnvironmentList] = useState<
    ReadonlyArray<IEnvUnionItem>
  >([]);
  // const [commonServiceID, setCommonServiceID] =
  //   useState<ReadonlyArray<Number>>();
  const [isServiceIDRequired, setIsServiceIDRequired] =
    useState<boolean>(false);
  const [sourceEnvID, setSourceEnvID] = useState<number>();
  const [targetEnvID, setTargetEnvID] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sourceValue, setSourceValue] = useState<string | null>();
  const [targetValue, setTargetValue] = useState<string | null>();
  const [buttonClassName, setButtonClassName] = useState<string>('gc-btn ');
  // const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [isSyncContent, setIsSyncContent] = useState<boolean>(false);
  const [sourceOptions, setSourceOptions] = useState<
    ReadonlyArray<{ label: string; value: string }>
  >([]);
  const [targetOptions, setTargetOptions] = useState<
    ReadonlyArray<{ label: string; value: string }>
  >([]);
  const [commonServices, setCommonServices] = useState<string[]>([]);
  const [syncMethod, setSyncMethod] = useState<string>('1');
  const [isEnvCheck, setIsEnvCheck] = useState<boolean>(false);
  const [envCheckPass, setEnvCheckPass] = useState<CommonStatusStep>(
    CommonStatusStep.Pending
  );
  const [envCheckTips, setEnvCheckTips] = useState<string>('');
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [confirmStep, setConfirmStep] = useState<CommonStatusStep>(
    CommonStatusStep.Pending
  );
  const [selectService, setSelectService] = useState<string[]>([]);
  const [clientApiChecked, setClientApiChecked] = useState<boolean>(true);
  const [isExceed12, setIsExceed12] = useState<boolean>(false);

  const optionalServiceList = [
    'Player',
    'Battle',
    // 'Party',
    // 'Lobby',
    'Matchmaking',
    'BattlePass',
    'Season',
    'DS Hosting',
    'Auto-Task',
    // 'Goals',
    'Friends',
    'Guild',
    'Mails',
    'Notifications',
    'Statistics',
    'Token',
    'Segments',
    'Telemetry',
    'Text Chat',
  ];

  // 数组内服务只展示子服务
  const optionalSubServiceList: { [key: string]: string[] } = {
    Battle: ['Party', 'Lobby', 'Custom Tags'],
    'Auto-Task': ['Goals', 'Season', 'BattlePass'],
    'DS Hosting': ['Gamemode', 'Fleet'],
  };

  const getTheSelectedUnionEnvironmentId = () => {
    const menuCheckedIDs: string[] = [];
    const commonSelectServices: string[] = [];
    unionEnvironmentList.forEach((item) => {
      item.checkedList.forEach((subItem) => {
        commonSelectServices.push(subItem);
      });
      if (item.checkedList.length > 0) {
        menuCheckedIDs.push(item.id);
      }
    });
    setSelectService(commonSelectServices);
    if (unionEnvironmentList.length > 0) {
      if (commonSelectServices.length === 0) {
        setIsServiceIDRequired(true);
      } else {
        setIsServiceIDRequired(false);
      }
    } else {
      setIsServiceIDRequired(false);
    }
  };
  // 服务同步 选中第二级
  const handleServiceGroup = (e: CheckboxChangeEvent, item: IEnvUnionItem) => {
    const isChecked = e.target.checked;
    setUnionEnvironmentList((prevList) =>
      prevList.map((listItem) =>
        listItem.id === item.id
          ? {
              ...listItem,
              checkedList: isChecked
                ? listItem.commonServices.map((subItem) => subItem.id)
                : [],
            }
          : listItem
      )
    );
  };

  const getFormattedSelectedValues = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const isMultiPlayerMenu = selectedMenu.commonServices.some(
      (item) => item.id === 'battlepass'
    );
    if (!isMultiPlayerMenu) {
      return values;
    }
    const preValuesHasBattlePass = selectedMenu.checkedList.includes(
      SubServiceID.BattlePass
    );
    const valuesHasBattlePass = values.includes(SubServiceID.BattlePass);

    if (preValuesHasBattlePass || valuesHasBattlePass) {
      return valuesHasBattlePass
        ? uniq([...values, SubServiceID.Season])
        : values.filter((item) => item !== SubServiceID.Season);
    }
    return values;
  };

  const getFormattedSelectedGamemodeValues = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const isMultiPlayerMenu = selectedMenu.commonServices.some(
      (item) =>
        item.id === SubServiceID.Matchmaking ||
        item.id === SubServiceID.SkillRating
    );
    if (!isMultiPlayerMenu) {
      return values;
    }
    const preValuesHasMatchmaking = selectedMenu.checkedList.includes(
      SubServiceID.Matchmaking
    );
    const valuesHasMatchmaking = values.includes(SubServiceID.Matchmaking);

    const preValuesSkillRating = selectedMenu.checkedList.includes(
      SubServiceID.SkillRating
    );
    const valuesHasSkillRating = values.includes(SubServiceID.SkillRating);

    const preValuesGamemode = selectedMenu.checkedList.includes(
      SubServiceID.Gamemode
    );
    const valuesHasGamemode = values.includes(SubServiceID.Gamemode);

    if (!isExceed12) {
      if (preValuesHasMatchmaking || valuesHasMatchmaking) {
        return valuesHasMatchmaking
          ? uniq([...values, SubServiceID.Gamemode])
          : values.filter((item) => item !== SubServiceID.Gamemode);
      }
      return values;
    }
    if (
      preValuesHasMatchmaking ||
      valuesHasMatchmaking ||
      preValuesSkillRating ||
      valuesHasSkillRating ||
      preValuesGamemode ||
      valuesHasGamemode
    ) {
      return valuesHasMatchmaking || valuesHasSkillRating || valuesHasGamemode
        ? uniq([...values, SubServiceID.Gamemode, SubServiceID.FactionSet])
        : values.filter(
            (item) =>
              item !== SubServiceID.Gamemode && item !== SubServiceID.FactionSet
          );
    }
    return values;
  };
  // 服务同步 选中第三级
  const handleSyncServiceChange = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const newValues = getFormattedSelectedValues(values, selectedMenu);
    const cuurnetValues = getFormattedSelectedGamemodeValues(
      newValues,
      selectedMenu
    );

    setUnionEnvironmentList((prevMenuList) =>
      prevMenuList.map((menuItem) => {
        if (menuItem.id === selectedMenu.id) {
          return {
            ...menuItem,
            // checkedList: i.commonServices
            //   .filter((subItem) => values.includes(subItem.id.toString()))
            //   .map((subItem) => subItem.id),
            checkedList: cuurnetValues,
          };
        }
        return menuItem;
      })
    );
  };

  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const updateCommonServices = (source: string, target: string) => {
    const { envList, selectedGame } = props;
    const sourceEnv = envList.find((env) => env.Name === source);
    const targetEnv = envList.find((env) => env.Name === target);
    const sourceGos = JSON.parse(sourceEnv?.GosParams || '{}');
    const targetGos = JSON.parse(targetEnv?.GosParams || '{}');
    let newIsExceed12 = false;

    if (
      sourceGos?.GameServiceVersion &&
      isVersionGreaterThan(sourceGos?.GameServiceVersion) &&
      targetGos?.GameServiceVersion &&
      isVersionGreaterThan(targetGos?.GameServiceVersion)
    ) {
      setIsExceed12(true);
      newIsExceed12 = true;
    }
    if (sourceEnv && targetEnv && selectedGame) {
      const sourceServices = serviceOpenList(selectedGame.gameID, sourceEnv.id);
      const targetServices = serviceOpenList(selectedGame.gameID, targetEnv.id);
      Promise.all([sourceServices, targetServices]).then(
        ([sourceRes, targetRes]) => {
          if (props.allServiceConfig) {
            // Status 已开通:1, 拒绝：2 排除增值服务, 必须两者环境都开通
            const sourceServiceIds = sourceRes
              .filter((service) => service.ServiceID && service.Status !== 2)
              .map((service) => service.ServiceID);
            const targetServiceIds = targetRes
              .filter((service) => service.ServiceID && service.Status !== 2)
              .map((service) => service.ServiceID);
            const sourceEnvID1 = sourceRes.find(
              (service) => service.EnvID
            )?.EnvID;
            const targetEnvID1 = targetRes.find(
              (service) => service.EnvID
            )?.EnvID;
            setSourceEnvID(sourceEnvID1 as number);
            setTargetEnvID(targetEnvID1 as number);

            const commonServiceIds = sourceServiceIds.filter((id) => {
              const serviceItem = props.allServiceConfig?.find(
                (it) => it.id === id
              );
              if (!serviceItem) {
                return false;
              }
              return (
                targetServiceIds.includes(id) &&
                optionalServiceList.includes(serviceItem?.Name)
              );
            });
            const commonServices = props.allServiceConfig
              .filter((config) => commonServiceIds.includes(config.id))
              .map((config) => {
                if (config.Business === 'g6') {
                  return config;
                }
                return null;
              })
              .filter((config) => config !== null) as IAPIServiceConfigItem[];
            // const commonServiceIDs = commonServices
            //   .filter((service) => service.id !== undefined)
            //   .map((service) => service.id as number);
            const sortOrder = [
              'Multiplayer',
              'Social',
              'Economy',
              'Engagement',
              'Analytics',
              'Content',
            ];
            commonServices.sort((a, b) => {
              const aIndex = sortOrder.indexOf(a.ParentName);
              const bIndex = sortOrder.indexOf(b.ParentName);

              // 处理不在排序列表中的情况（放在最后）
              const aSortIndex = aIndex === -1 ? sortOrder.length : aIndex;
              const bSortIndex = bIndex === -1 ? sortOrder.length : bIndex;

              return aSortIndex - bSortIndex;
            });
            const menuMap: { [y: string]: IAPIServiceConfigItem[] } = {};
            commonServices.forEach((item) => {
              if (menuMap[item.ParentName]) {
                menuMap[item.ParentName].push(item);
              } else {
                menuMap[item.ParentName] = [item];
              }
            });
            const currentCommonServices: string[] = [];
            const list: IEnvUnionItem[] = [];
            const menuCheckedIDs: string[] = [];
            Object.keys(menuMap).forEach((item) => {
              const checkedList: string[] = [];
              // menuMap[item].forEach((subItem) => {
              //   checkedList.push(subItem.id as number);
              // });
              menuCheckedIDs.push(item);
              const unionCommonServices: { id: string; name: string }[] = [];
              menuMap[item].forEach((it) => {
                if (
                  it.Name === 'Battle' ||
                  it.Name === 'Auto-Task' ||
                  (it.Name === 'DS Hosting' && newIsExceed12)
                ) {
                  const sourceBattle = sourceRes.find(
                    (sourceItem) => sourceItem.ServiceItem?.Name === it.Name
                  );
                  const targetBattle = targetRes.find(
                    (targetItem) => targetItem.ServiceItem?.Name === it.Name
                  );
                  if (
                    sourceBattle?.ServiceItem?.SubServiceNames &&
                    targetBattle?.ServiceItem?.SubServiceNames
                  ) {
                    const sourceBattleSub =
                      sourceBattle?.SubServiceName?.filter(
                        (sourceBattleSubItem: any) =>
                          sourceBattleSubItem?.status === 1 &&
                          sourceBattleSubItem?.stage === 'opened'
                      );
                    const targetBattleSub =
                      targetBattle?.SubServiceName?.filter(
                        (sourceBattleSubItem: any) =>
                          sourceBattleSubItem?.status === 1 &&
                          sourceBattleSubItem?.stage === 'opened'
                      );
                    const commonSub: string[] = [];
                    sourceBattleSub.forEach((subItem: any) => {
                      const commonBattleSubItem = targetBattleSub.find(
                        (subIt: any) =>
                          subIt?.subserviceName === subItem?.subserviceName
                      );
                      if (commonBattleSubItem?.subserviceName) {
                        commonSub.push(commonBattleSubItem.subserviceName);
                      }
                    });
                    if (commonSub.length !== 0) {
                      const optionalSubServices: string[] =
                        optionalSubServiceList[it.Name].map((optionalSub) => {
                          return toLowerCaseAndRemoveSpaces(optionalSub);
                        });
                      if (
                        it.Name === 'DS Hosting' &&
                        commonSub.includes('gamemode')
                      )
                        commonSub.push('fleet');
                      [...commonSub]
                        .sort((a, b) => {
                          const aIndex = optionalSubServices.indexOf(a);
                          const bIndex = optionalSubServices.indexOf(b);
                          return aIndex > bIndex ? 1 : -1;
                        })
                        .forEach((subItem) => {
                          if (optionalSubServices.includes(subItem)) {
                            const subName = optionalSubServiceList[
                              it.Name
                            ].find(
                              (nameItem) =>
                                toLowerCaseAndRemoveSpaces(nameItem) === subItem
                            );
                            unionCommonServices.push({
                              id: subItem,
                              name: subName || subItem,
                            });
                            checkedList.push(subItem);
                            currentCommonServices.push(subItem);

                            if (subItem === 'goals') {
                              unionCommonServices.push({
                                id: SubServiceID.Season,
                                name: 'Season',
                              });
                              checkedList.push(SubServiceID.Season);
                              currentCommonServices.push(SubServiceID.Season);
                            }
                          }
                        });
                    }
                  }
                } else {
                  if (it.Name !== 'DS Hosting') {
                    if (it.Name === 'Matchmaking' && newIsExceed12) {
                      unionCommonServices.push({
                        id: SubServiceID.Matchmaking,
                        name: 'Matchmaker',
                      });
                      checkedList.push(SubServiceID.Matchmaking);
                      currentCommonServices.push(SubServiceID.Matchmaking);

                      unionCommonServices.push({
                        id: SubServiceID.SkillRating,
                        name: 'SkillRating',
                      });
                      checkedList.push(SubServiceID.SkillRating);
                      currentCommonServices.push(SubServiceID.SkillRating);

                      unionCommonServices.push({
                        id: SubServiceID.FactionSet,
                        name: 'FactionSet',
                      });
                      checkedList.push(SubServiceID.FactionSet);
                      currentCommonServices.push(SubServiceID.FactionSet);
                    } else {
                      unionCommonServices.push({
                        id: it.Name,
                        name: it.Name,
                      });
                      checkedList.push(it.Name);
                      currentCommonServices.push(it.Name);
                    }
                  }
                }
              });

              const getTitle = () => {
                return item.toUpperCase()
                  ? item.toUpperCase()[0] + item.slice(1)
                  : item;
              };

              list.push({
                // commonServices: menuMap[item],
                commonServices: unionCommonServices,
                checkedList,
                title: getTitle(),
                id: item,
                checked: true,
                indeterminate: false,
              });
            });
            // setCommonServiceID(commonServiceIDs);
            // setMenuCheckedID(menuCheckedIDs);
            setUnionEnvironmentList(list);
            // setCommonServices(commonServices);
            setCommonServices(currentCommonServices);
            setIsLoading(false);
          }
        }
      );
    }
  };

  const handleSourceChange = (value: string) => {
    setSourceValue(value);
    setTargetValue(null);
    form.setFieldsValue({ Target: null });
  };

  const handleTargetChange = (value: string) => {
    setIsLoading(true);
    setTargetValue(value);
    if (sourceValue) {
      updateCommonServices(sourceValue, value);
    }
    setEnvCheckPass(CommonStatusStep.Pending);
    setEnvCheckTips('');
    setIsEnvCheck(false);
  };

  const onCloseSync = () => {
    setSourceValue(null);
    setTargetValue(null);
    form.resetFields(); // 清空表单
    // setIsUpGrade(false);
    // closeHandler();
    console.log('父类关闭');
    props.onClose();
    setIsSyncContent(false);
    setEnvCheckTips('');
    setIsEnvCheck(false);
    setClientApiChecked(true);
    setIsExceed12(false);
  };

  const syncData = () => {
    if (
      props.selectedGame &&
      sourceEnvID &&
      targetEnvID &&
      selectService &&
      commonServices
    ) {
      // const allServices: string[] = [];
      // commonServices.forEach((item) => {
      //   allServices.push(item);
      // });
      const syncParams: IGameEnvSync = {
        gameID: props.selectedGame.gameID,
        sourceEnvID,
        targetEnvID,
        // ServiceIds: commonServiceID.slice(),
        transparentData: {
          sync_method: syncMethod,
          all_services: commonServices.concat(['api-control']),
          services: clientApiChecked
            ? selectService.concat(['api-control'])
            : selectService,
        },
      };
      return syncParams;
    }
    return null as unknown as IGameEnvSync;
  };
  const gameEnvSync: IGameEnvSync = syncData();

  useEffect(() => {
    setSourceOptions(
      props.envList.map((env) => ({ label: env.Name, value: env.Name }))
    );
    setTargetOptions(
      props.envList
        .map((env) => {
          if (sourceValue && env.Name === sourceValue) {
            return { label: '', value: '' };
          }
          return { label: env.Name, value: env.Name };
        })
        .filter((v) => v.label || v.value)
    );
  }, [props.envList, sourceValue]);

  useEffect(() => {
    if (unionEnvironmentList) {
      getTheSelectedUnionEnvironmentId();
    }
  }, [unionEnvironmentList]);

  useEffect(() => {
    setSourceOptions(
      props.envList.map((env) => ({ label: env.Name, value: env.Name }))
    );
    setTargetOptions(
      props.envList.map((env) => ({ label: env.Name, value: env.Name }))
    );
  }, [props.envList]);

  useEffect(() => {
    if (sourceValue && targetValue) {
      setButtonClassName('gc-btn gc-btn-primary');
    } else {
      setButtonClassName('gc-btn gc-btn-primary:disabled');
    }
  }, [sourceValue, targetValue]);

  const handleSyncMethodChange = (value: string) => {
    setSyncMethod(value);
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setConfirmStep(CommonStatusStep.Pending);
  };

  const goSyncTask = (isConfirm?: boolean) => {
    let envItem = props.envList.find(
      (item) => item.id.toString() === props.selectedEnv
    );
    if (isConfirm) {
      envItem = props.envList.find((item) => item.id === targetEnvID);
    }
    history.push(
      `/studio/${props.selectedGame?.studioID}/audithub?gameId=${props.selectedGame?.gameID}&envId=${envItem?.Guid}&task=sync&subtask=516`
    );
  };

  const confirmClick = async () => {
    if (confirmStep === CommonStatusStep.Pending) {
      if (gameEnvSync.transparentData?.services?.length === 0) {
        return false;
      }
      setIsSyncContent(true);
    }
    if (confirmStep === CommonStatusStep.Resolve) {
      goSyncTask(true);
    }
    return true;
  };

  const renderConfirmModal = () => {
    if (showConfirmModal) {
      return (
        <ModalWrap
          width="434px"
          onClose={closeConfirmModal}
          title={
            confirmStep === CommonStatusStep.Resolve
              ? getFormatMessage('task_submit_success')
              : getFormatMessage('environment_sync')
          }
          oKText={
            confirmStep === CommonStatusStep.Resolve
              ? getFormatMessage('go_view')
              : getFormatMessage('confirm')
          }
          cancelText={getFormatMessage('cancel')}
          onOk={confirmClick}
          // className="fail-dialog"
        >
          <div>
            {confirmStep === CommonStatusStep.Resolve
              ? getFormatMessage('task_submit_success_tips')
              : getFormatMessage('env_sync_confirm_tips')}
          </div>
        </ModalWrap>
      );
    }
  };

  const isVersionGreaterThan = (
    versionStr: string,
    targetVersion = '1.12.0'
  ) => {
    // 1. 去掉可能的 'v' 前缀，并去除前后空格
    const cleanVersion = versionStr.trim().replace(/^v/i, '').replace(/-.*$/, '');

    // 2. 检查格式是否合法
    if (!/^\d+(\.\d+)+$/.test(cleanVersion)) {
      return false;
    }

    // 3. 拆分版本号为数字数组，例如 "1.12.0" → [1, 12, 0]
    const currentVersionParts = cleanVersion.split('.').map(Number);
    const targetVersionParts = targetVersion.split('.').map(Number);

    // 4. 比较每一位数字
    const maxLength = Math.max(
      currentVersionParts.length,
      targetVersionParts.length
    );

    for (let i = 0; i < maxLength; i++) {
      const current = currentVersionParts[i] || 0; // 如果某一位不存在，默认为 0
      const target = targetVersionParts[i] || 0;

      if (current > target) {
        return true; // 当前版本某一位更大，整体更大
      }
      if (current < target) {
        return false; // 当前版本某一位更小，整体更小
      }
      // 如果相等，继续比较下一位
    }

    // 所有位都相等
    return true;
  };

  const clickEnvCheck = () => {
    setIsEnvCheck(true);
    const sourceItem = props.envList.find((item) => sourceValue === item.Name);
    const targetItem = props.envList.find((item) => targetValue === item.Name);
    const sourceGos = JSON.parse(sourceItem?.GosParams || '{}');
    const targetGos = JSON.parse(targetItem?.GosParams || '{}');
    if (
      sourceGos?.GameServiceVersion &&
      targetGos?.GameServiceVersion &&
      sourceGos?.GameServiceVersion === targetGos?.GameServiceVersion
    ) {
      if (
        sourceGos?.GameServiceVersion &&
        isVersionGreaterThan(sourceGos?.GameServiceVersion) &&
        targetGos?.GameServiceVersion &&
        isVersionGreaterThan(targetGos?.GameServiceVersion)
      ) {
        setIsExceed12(true);
      }
      setEnvCheckPass(CommonStatusStep.Resolve);
    } else {
      if (!sourceGos?.GameServiceVersion || !targetGos?.GameServiceVersion) {
        setEnvCheckTips(getFormatMessage('no_valid_service_version'));
      } else {
        setEnvCheckTips(
          getFormatMessage('detected_incompatible_service_version')
        );
      }
      setIsExceed12(false);
      setEnvCheckPass(CommonStatusStep.Reject);
    }
    setIsEnvCheck(false);
  };

  const renderEnvCheck = () => {
    if (
      !sourceValue ||
      !targetValue ||
      envCheckPass === CommonStatusStep.Resolve
    ) {
      return null;
    }
    if (envCheckPass === CommonStatusStep.Reject) {
      return (
        <div style={{ fontSize: 12, color: '#86909C' }}>
          <div style={{ display: 'flex', marginBottom: 8, fontSize: 14 }}>
            <img
              src={errorIcon}
              style={{
                display: 'block',
                width: 16,
                height: 16,
                marginRight: 8,
                marginTop: 4,
              }}
            />
            <span>{getFormatMessage('service_version_error')}</span>
          </div>
          <div>{envCheckTips}</div>
        </div>
      );
    }
    if (!isEnvCheck) {
      return (
        <div style={{ fontSize: 14, color: '#5764F1', marginTop: 4 }}>
          <span onClick={clickEnvCheck} style={{ cursor: 'pointer' }}>
            <img
              src={envCheckIcon}
              style={{
                display: 'inline-block',
                width: 16,
                height: 16,
                marginRight: 4,
                marginTop: -2,
              }}
            />
            {getFormatMessage('env_check')}
          </span>
        </div>
      );
    }
    if (isEnvCheck) {
      return (
        <div style={{ display: 'flex' }}>
          <img
            src={loadingIcon}
            style={{
              display: 'block',
              width: 16,
              height: 16,
              marginTop: 4,
              marginRight: 8,
              animation: 'rotate 1s linear infinite',
            }}
          />
          <span style={{ fontSize: 14, color: '#86909C' }}>
            {getFormatMessage('env_check_progress')}
          </span>
        </div>
      );
    }
    return null;
  };

  const handleClientApi = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked;
    setClientApiChecked(isChecked);
  };

  const renderContent = () => {
    const emptyText = (
      <Empty
        image={emptyIcon}
        imageStyle={{ height: 60 }}
        description={
          <span style={{ fontSize: '12px' }}>
            {getFormatMessage('no_services_synced')}
          </span>
        }
      />
    );
    return (
      <div
        style={{ maxWidth: '680px', overflow: 'auto', padding: '10px 0px' }}
        className="sync-drawer-box"
      >
        <div>
          <p
            className="select-env"
            style={{ fontWeight: 600, fontSize: '16px', color: '#000' }}
          >
            {getFormatMessage('select_env')}
          </p>
          <div style={{ fontSize: 14, fontWeight: 400, marginTop: '20px' }}>
            <div
              style={{ marginBottom: '6px', color: '#4E5969', display: 'flex' }}
            >
              <span style={{ display: 'block', width: '346px' }}>
                {getFormatMessage('org_env')}
              </span>
              <span>{getFormatMessage('tar_env')}</span>
            </div>
            <Form
              name="basic"
              className="sync-form"
              wrapperCol={{ span: 16 }}
              style={{ display: 'flex' }}
              autoComplete="off"
              form={form}
            >
              <Form.Item name="Source" style={{ width: 308, height: 32 }}>
                <Select
                  className="sync-select"
                  style={{ width: 308, height: 32 }}
                  onChange={handleSourceChange}
                  options={sourceOptions.slice()}
                  value={sourceValue}
                  virtual={false}
                />
              </Form.Item>
              <ArrowRightOutlined
                className="jiantou-icon"
                style={{ color: '#5764F1' }}
              />

              <Form.Item name="Target" style={{ width: 308, height: 32 }}>
                <Select
                  className="sync-select"
                  style={{ width: 308, height: 32 }}
                  allowClear={false}
                  onChange={handleTargetChange}
                  options={targetOptions.slice()}
                  value={targetValue}
                  virtual={false}
                />
              </Form.Item>
            </Form>
          </div>
          {renderEnvCheck()}
          {sourceValue &&
            targetValue &&
            envCheckPass === CommonStatusStep.Resolve && (
              <div style={{ marginTop: 24 }}>
                <p
                  className="select-env"
                  style={{ fontWeight: 600, fontSize: '16px', color: '#000' }}
                >
                  {getFormatMessage('sync_config')}
                </p>
                <div className="services-group">
                  <p style={{ fontWeight: 500, marginTop: 4 }}>
                    {getFormatMessage('select_services')}
                    <span
                      style={{
                        display: 'block',
                        fontSize: 12,
                        color: '#1D2129',
                        marginTop: 9,
                        fontWeight: 400,
                      }}
                    >
                      {getFormatMessage('services_already_started_desc')}
                    </span>
                  </p>
                  {isLoading ? (
                    // loadingContent()
                    <div className="loading-box">
                      <img src={loadingIcon} className="loading-icon" />
                      <div className="loading-tips">
                        {getFormatMessage('being_sync_not_close_page')}
                      </div>
                    </div>
                  ) : (
                    <>
                      {commonServices && commonServices.length > 0 ? (
                        <>
                          <div className="services-select services-unselect">
                            <div className="services-select-item">
                              {unionEnvironmentList.map(
                                (item: IEnvUnionItem) => {
                                  return (
                                    <div
                                      key={item.id}
                                      className="services-select-item-check"
                                    >
                                      <Checkbox
                                        className="sync-item-left"
                                        onChange={(e) =>
                                          handleServiceGroup(e, item)
                                        }
                                        indeterminate={
                                          item.checkedList?.length > 0 &&
                                          item.checkedList.length <
                                            item.commonServices.length
                                        }
                                        checked={
                                          item.checkedList?.length > 0 &&
                                          item.checkedList.length ===
                                            item.commonServices.length
                                        }
                                      >
                                        {item.title}
                                      </Checkbox>
                                      <div className="sync-item">
                                        <Checkbox.Group
                                          onChange={(e) =>
                                            handleSyncServiceChange(e, item)
                                          }
                                          value={item.checkedList.map((id) =>
                                            id.toString()
                                          )}
                                        >
                                          <Row className="sync-zilei">
                                            {item.commonServices.map(
                                              (subItem) => {
                                                let isDisabled = false;
                                                // const disableTip =
                                                //     isDisabled &&
                                                //     getFormatMessage(
                                                //       'season_sync_tip'
                                                //     );
                                                let disableTip = '';
                                                if (
                                                  subItem.id ===
                                                    SubServiceID.Season &&
                                                  item.checkedList.includes(
                                                    SubServiceID.BattlePass
                                                  )
                                                ) {
                                                  isDisabled = true;
                                                  disableTip =
                                                    getFormatMessage(
                                                      'season_sync_tip'
                                                    );
                                                }
                                                if (
                                                  subItem.id ===
                                                    SubServiceID.Gamemode &&
                                                  (item.checkedList.includes(
                                                    SubServiceID.SkillRating
                                                  ) ||
                                                    item.checkedList.includes(
                                                      SubServiceID.Matchmaking
                                                    ))
                                                ) {
                                                  isDisabled = true;
                                                  disableTip =
                                                    getFormatMessage(
                                                      'gamemode_sync_tip'
                                                    );
                                                }
                                                if (
                                                  subItem.id ===
                                                    SubServiceID.FactionSet &&
                                                  (item.checkedList.includes(
                                                    SubServiceID.SkillRating
                                                  ) ||
                                                    item.checkedList.includes(
                                                      SubServiceID.Matchmaking
                                                    ) ||
                                                    item.checkedList.includes(
                                                      SubServiceID.Gamemode
                                                    ))
                                                ) {
                                                  isDisabled = true;
                                                  disableTip = getFormatMessage(
                                                    'factionset_sync_tip'
                                                  );
                                                }
                                                let toolTips = '';
                                                if (
                                                  subItem.name === 'Telemetry'
                                                ) {
                                                  toolTips =
                                                    getFormatMessage(
                                                      'event_sync_tips'
                                                    );
                                                } else if (
                                                  subItem.name === 'Statistics'
                                                ) {
                                                  toolTips = getFormatMessage(
                                                    'statistics_sync_tips'
                                                  );
                                                } else if (
                                                  subItem.name === 'Fleet'
                                                ) {
                                                  toolTips =
                                                    getFormatMessage(
                                                      'ds_sync_tips'
                                                    );
                                                }

                                                const checkboxNode = (
                                                  <Checkbox
                                                    value={subItem.id.toString()}
                                                    disabled={isDisabled}
                                                  >
                                                    {subItem.name}
                                                    {toolTips && (
                                                      <AutoTooltip
                                                        title={toolTips}
                                                        placement="top"
                                                      >
                                                        <img
                                                          src={questionIcon}
                                                          style={{
                                                            display:
                                                              'inline-block',
                                                            width: 12,
                                                            height: 12,
                                                            marginLeft: 4,
                                                            marginTop: -2,
                                                          }}
                                                        />
                                                      </AutoTooltip>
                                                    )}
                                                  </Checkbox>
                                                );
                                                return (
                                                  <Col
                                                    className="sync-zilei-col"
                                                    key={subItem.id}
                                                  >
                                                    <CustomPopover
                                                      content={disableTip}
                                                    >
                                                      {checkboxNode}
                                                    </CustomPopover>
                                                  </Col>
                                                );
                                              }
                                            )}
                                          </Row>
                                        </Checkbox.Group>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                              <div className="services-select-item-check">
                                <Checkbox
                                  className="sync-item-left"
                                  onChange={(e) => handleClientApi(e)}
                                  checked={clientApiChecked}
                                >
                                  Client API Control
                                </Checkbox>
                                <div className="sync-item">
                                  <Row className="sync-zilei">
                                    <Col className="sync-zilei-col">
                                      <Checkbox
                                        checked={clientApiChecked}
                                        onChange={(e) => handleClientApi(e)}
                                      >
                                        All Services
                                        <AutoTooltip
                                          title={getFormatMessage(
                                            'client_api_sync_tips'
                                          )}
                                          placement="top"
                                        >
                                          <img
                                            src={questionIcon}
                                            style={{
                                              display: 'inline-block',
                                              width: 12,
                                              height: 12,
                                              marginLeft: 4,
                                              marginTop: -2,
                                            }}
                                          />
                                        </AutoTooltip>
                                      </Checkbox>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <List
                            locale={{ emptyText }}
                            bordered
                            style={{ width: 450 }}
                          />
                          <p
                            style={{
                              fontSize: 12,
                              color: '#666666',
                              marginTop: 5,
                            }}
                          >
                            {getFormatMessage(
                              'verify_services_activated_both_desc'
                            )}
                          </p>
                          {isServiceIDRequired && (
                            <p
                              style={{
                                fontSize: 10,
                                color: 'red',
                              }}
                            >
                              {getFormatMessage('select_one_service')}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                <p
                  className="select-env"
                  style={{
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#1D2129',
                    marginTop: 20,
                  }}
                >
                  {getFormatMessage('sync_method')}
                </p>
                <div>
                  <div style={{ fontSize: '12px', color: '#1d2129' }}>
                    {getFormatMessage('sync_method_desc')}
                  </div>
                  <Select
                    className="sync-select"
                    style={{ height: 32, marginTop: 8 }}
                    allowClear={false}
                    onChange={handleSyncMethodChange}
                    value={syncMethod}
                  >
                    <Select.Option value="1">
                      {getFormatMessage('full_replace')}
                    </Select.Option>
                    <Select.Option value="2" disabled>
                      {getFormatMessage('add_on')}
                    </Select.Option>
                  </Select>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  };

  const renderSyncTask = () => {
    return (
      <EnvSyncDetail
        syncData={gameEnvSync}
        closeModal={onCloseSync}
        changeConfirmStep={setConfirmStep}
        closeConfirmModal={closeConfirmModal}
        envList={props.envList}
        // modalVisible={modalVisible}
        // isSyncContent={isSyncContent}
      />
    );
  };

  const handleOkSync = () => {
    // 同步结果展示改成二次弹框
    // setIsSyncContent(true);
    setShowConfirmModal(true);
  };

  const footer = (isSyncContent: boolean) => {
    if (!isSyncContent) {
      return (
        <div>
          <Button
            className="gc-btn-default sync-cancel"
            style={{ width: '80px', borderRadius: '4px' }}
            onClick={onCloseSync}
            // disabled={btnLoading}
          >
            {getFormatMessage('cancel')}
          </Button>
          <Button
            // loading={btnLoading}
            onClick={handleOkSync}
            className={buttonClassName}
            style={{ minWidth: '80px', borderRadius: '4px' }}
            disabled={
              !(sourceValue && targetValue) ||
              (isServiceIDRequired && !clientApiChecked) ||
              (unionEnvironmentList &&
                unionEnvironmentList.length === 0 &&
                !clientApiChecked) ||
              envCheckPass !== CommonStatusStep.Resolve
            }
          >
            {getFormatMessage('sync')}
          </Button>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {isSyncContent ? (
        renderSyncTask()
      ) : (
        <Drawer
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex' }}>
                <span>{getFormatMessage('environment_sync')}</span>
                <span
                  style={{
                    display: 'flex',
                    color: '#5764F1',
                    fontSize: 12,
                    marginLeft: 16,
                    marginTop: 4,
                    cursor: 'pointer',
                    fontWeight: 400,
                  }}
                  onClick={() => goSyncTask(false)}
                >
                  <span>{getFormatMessage('view_sync_task')}</span>
                  <img
                    src={arrowRightUpIcon}
                    style={{
                      width: 12,
                      height: 12,
                      marginLeft: 2,
                      marginTop: 8,
                    }}
                  />
                </span>
              </div>
              <img
                src={closeIcon}
                className="sync-close-icon"
                onClick={onCloseSync}
              />
            </div>
          }
          placement="right"
          width={720}
          closable={false}
          onClose={onCloseSync}
          visible={props.visible}
          headerStyle={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            marginLeft: '3px',
          }}
          footer={footer(isSyncContent)}
        >
          {renderContent()}
        </Drawer>
      )}
      {renderConfirmModal()}
    </>
  );
};
